export default "__VITE_ASSET__Bkn7ebVy__"